<template>
  <div id='un_edit_options-wrap'>
    <div v-show='activeControl === "scaleRotate"' class='controls-scale-rotate'>
      <div class='control-item-row'>
        <Slider
          height="100px"
          class='mar_r'
          v-model='imageState.scale'
          :min='imageState.scaleMin'
          :max='100'
          :step='1'
          :showTooltip='false'
          :disabled='!imageIsSelected'/>
          <div class='control-rotate' v-tap='(e) => handleRotate()'>
            <!-- <Rotate45 /> -->
            <i class="material-icons">
              rotate_right
            </i>
          </div>
      </div>
    </div>

    <div v-show='activeControl === "light"' class='controls-brightness-contrast'>
      <div v-if='filteringAllowed()'>
        <div class='control-item-row'>
          <span class='control-label'>Brightness:</span>
          <Slider
            height="100px"
            class='mar_l'
            :min='-1'
            :max='1'
            :step='0.01'
            @change='(value) => handleSliderChange("brightness", value)'
            v-model='imageState.brightness'
            :disabled='!imageIsSelected'/>
        </div>

        <div class='control-item-row'>
          <span class='control-label'>Contrast:</span>
          <Slider
            class='mar_l'
            height="100px"
            :min='-1'
            :max='1'
            :step='0.01'
            @change='(value) => handleSliderChange("contrast", value)'
            v-model='imageState.contrast'
            :disabled='!imageIsSelected'/>
        </div>
      </div>
      <div class='cannot-apply-filter-warning' v-if='!filteringAllowed()'>
        <p>
          The image is too large to adjust brightness and contrast.
        </p>
      </div>
    </div>

    <div v-show='activeControl === "filter"' class='controls-filters'>
      <ul v-if='filteringAllowed()'>
        <!-- 'No Filter' disabled filter -->
        <li
          :class='{disabled: !imageIsSelected, selected: imageState.colorFilters[6].modelState}'
          :key='imageState.colorFilters[6].name + "-" + imageState.colorFilters[6].index'
          @click='(e) => applyColorFilter(imageState.colorFilters[6], 6)'>
            <img class='filter-img-el' :src="require(`./../../../assets/${imageState.colorFilters[6].img}`)">

          <span class='control-label'>
            {{imageState.colorFilters[6].instanceName}}
          </span>
        </li>

        <!-- Enumerate all filters, listing them side by side -->
        <li
          v-for='(colorFilter, i) in imageState.colorFilters.slice(0, -1)'
          :class='{disabled: !imageIsSelected, selected: colorFilter.modelState}'
          :key='colorFilter.name + "-" + i'
          @click='(e) => applyColorFilter(colorFilter, i)'
        >
          <img class='filter-img-el' :src="require(`./../../../assets/${colorFilter.img}`)">
          <span class='control-label'>
            {{colorFilter.instanceName}}
          </span>
        </li>
      </ul>

      <div class='cannot-apply-filter-warning' v-if='!filteringAllowed()'>
        <p>
          The image is too large for filters to be applied.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {f as fabric} from '$utilities/fabric-and-extensions'
import {getScaleFactor} from '$utilities/imageSetting'
import {isThisMobileDevice} from '$utilities/device'
import {
  // RENDER_START_EVENT,
  unUi
} from '@/components/EventBuses'
import {Slider} from 'element-ui'
import Rotate45 from '$svgs/Rotate45'

export default {
  props: [
    'activeControl',
    'canvas',
    'currentImage',
    'imageIsSelected'
  ],

  data () {
    return {
      currentlyRotating: false,

      isMobile: isThisMobileDevice(),

      imageState: {
        scale: null,
        scaleMin: null,
        brightness: 0,
        contrast: 0,
        colorFilters: [
          {index: 2, name: 'polaroid', modelState: false, instanceName: 'Polaroid', img: '2-polaroid.png'},
          {index: 3, name: 'grayscale', modelState: false, instanceName: 'Grayscale', img: '3-grayscale.png'},
          {index: 4, name: 'sepia', modelState: false, instanceName: 'Sepia', img: '4-sepia.png'},
          {index: 5, name: 'vintage', modelState: false, instanceName: 'Vintage', img: '5-vintage.png'},
          {index: 6, name: 'kodachrome', modelState: false, instanceName: 'Kodachrome', img: '6-kodachrome.png'},
          {index: 7, name: 'technicolor', modelState: false, instanceName: 'Technicolor', img: '7-technicolor.png'},
          {index: 8, name: 'no filter', modelState: true, instanceName: 'No Filter', img: '1-no-filter.png'}
        ]
      },

      filterIndexes: {
        brightness: 0,
        contrast: 1
      },

      filterImages: {
        activeImage: null,
        canvases: [],
        size: 35
      }
    }
  },

  watch: {
    currentImage: function (newImage, oldImage) {
      if (!newImage) { return }

      this.resetImage()
    },

    'imageState.scale': function (value) {
      var percentValue = value / 100

      if (this.canvas && this.canvas.getActiveObject()) {
        this.canvas.getActiveObject().set({scaleX: percentValue, scaleY: percentValue})
        this.canvas.renderAll()

        setTimeout(() => {
          if (this.imageState.scale !== (this.currentImage.scaleFactor * 100)) {
            unUi.$emit('scaleChanged')
          }
        }, 0)
      }
    },

    'imageState.brightness': function (value) {
      this.applyFilterValue(
        value,
        this.filterIndexes.brightness,
        'brightness'
      )

      if (this.imageState.brightness !== 0) {
        unUi.$emit('lightChanged')
      }
    },

    'imageState.contrast': function (value) {
      this.applyFilterValue(
        value,
        this.filterIndexes.contrast,
        'contrast'
      )

      if (this.imageState.contrast !== 0) {
        unUi.$emit('lightChanged')
      }
    }

    // TODO, Revisit
    // imageList: function (value) {
    //   if (value.length === 0) {
    //     this.imageState.colorFilters.forEach(cFilter => {
    //       // cFilter.modelState = false
    //       cFilter.modelState = cFilter.index === 0
    //     })
    //   }
    // },

    // TODO REVISIT we want this to happen when an image is added?
    // initialUserImageScale: function (value) {
    //   this.setInitialScaleSliderValue()
    // }
  },

  methods: {
    filteringAllowed () {
      if (!this.canvas) {
        return true
      }

      let fabricImage = this.canvas.getActiveObject()

      if (!fabricImage) {
        return true
      }

      let maxTextureArea = fabric.textureSize * fabric.textureSize
      let requiredTextureArea = fabricImage.width * fabricImage.height

      // Helpful for determining the threshhold.
      // At the moment the binary "is this less than the total allotted texture area?"
      // is not working 100% of the time.
      //
      // console.log({
      //   maxTextureArea,
      //   requiredTextureArea,
      //   ratio: (requiredTextureArea / maxTextureArea),
      //   diff: (maxTextureArea - requiredTextureArea)
      // })

      return maxTextureArea > requiredTextureArea
    },

    handleSliderChange (property, value) {
      if (!this.isMobile) { return }

      if (property === 'brightness') {
        this.applyFilterValue(
          value,
          this.filterIndexes.brightness,
          'brightness'
        )

        if (this.imageState.brightness !== 0) {
          unUi.$emit('lightChanged')
        }
      }

      if (property === 'contrast') {
        this.applyFilterValue(
          value,
          this.filterIndexes.contrast,
          'contrast'
        )

        if (this.imageState.contrast !== 0) {
          unUi.$emit('lightChanged')
        }
      }
    },

    applyFilterValue (value, filterIndex, prop) {
      var obj = this.canvas.getActiveObject()
      obj.filters[filterIndex][prop] = parseFloat(value)
      obj.applyFilters()
      this.canvas.renderAll()
    },

    /* not used at this time
    buildFilterList () {
      var vm = this

      let scaleFactor
      this.imageState.colorFilters.forEach((cFilter, i) => {
        if (vm.filterImages.canvases[i]) {
          vm.filterImages.canvases[i].dispose()
        }

        fabric.Image.fromURL(this.filterImages.activeImage, function (IMAGE) {
          vm.filterImages.canvases[i] = new fabric.Canvas('filter_image-' + cFilter.index, {
            preserveObjectStacking: true,
            width: vm.filterImages.size,
            height: vm.filterImages.size
          })

          scaleFactor = vm.filterImages.size / IMAGE.width

          IMAGE.originX = 'center'
          IMAGE.originY = 'center'
          IMAGE.scaleX = scaleFactor * 2
          IMAGE.scaleY = scaleFactor * 2
          IMAGE.left = vm.filterImages.size / 2
          IMAGE.top = vm.filterImages.size / 2
          IMAGE.hasControls = false
          IMAGE.hasBorders = false
          IMAGE.selectable = false
          IMAGE.draggable = false

          // ROTATE TO COMPENSATE FOR EXIF ORIENTATION:
          if (vm.currentImage.exifOrientation) {
            IMAGE.angle = vm.currentImage.exifOrientation
          }

          vm.filterImages.canvases[i].add(IMAGE)

          if (cFilter.index !== 8) {
            IMAGE.filters[cFilter.index] = new fabric.Image.filters[cFilter.instanceName]()
            IMAGE.applyFilters()
          }
          vm.filterImages.canvases[i].renderAll()
        }, { crossOrigin: 'anonymous' })
      })
      // this.loading = false
    },
    */

    applyColorFilter (colorFilter, filterIndex) {
      // TODO
      // the colorFilter object has an `index` attribute
      // the filterIndex attribute is not the same.

      // Grab the active fabric.js canvas object.
      var obj = this.canvas.getActiveObject()

      // Grab the first two. Not sure why.
      obj.filters = _.take(obj.filters, 2)

      // Loop every filter and turn them off?
      // Are these global objects?
      // An image can only have one filter applied at a time.
      // The state for this should not live globally, it should live
      // on the image or the image or a proxy that represents the
      // current asset being manipulated.
      this.imageState.colorFilters.forEach(cFilter => {
        cFilter.modelState = false
      })

      // Activate the chosen filter, by index.
      // this is not the colorFilter.index but rather
      // the index of the filter in the collection of them all?
      //
      // let's eliminate the index concept entirely and use the names of
      // these filters. we can look them up by slug, ie, 'vintage'
      //
      // we can also store that value, 'vintage' on the image/image-proxy
      // and use it to determine what needs to happen at the actual
      // rendering layer

      this.imageState.colorFilters[filterIndex].modelState = true

      // Let's separate these concerns, too.
      // We can have a specific 'removeFilter' click callback
      // instead of applyColorFilter() with a 'magic' value of 8,
      // let's just remove it entirely.
      if (colorFilter.index !== 8) {
        obj.filters[colorFilter.index] = new fabric.Image.filters[colorFilter.instanceName]()
        unUi.$emit('filterChanged')
      } else if (colorFilter.index === 8) {
        unUi.$emit('filterRemoved')
      }

      obj.applyFilters()
      this.canvas.renderAll()
    },

    // TODO
    removeColorFilter () {

    },

    handleRotate () {
      if (this.currentlyRotating) {
        return
      }

      this.currentlyRotating = true
      let activeObject = this.canvas.getActiveObject()
      let currentAngle = activeObject.get('angle')
      let newAngle = currentAngle
      newAngle += 90

      let newScale = getScaleFactor(activeObject, this.currentImage.exifOrientation, this.canvas, newAngle)
      this.imageState.scale = newScale * 100
      this.imageState.scaleMin = newScale * 100

      activeObject.animate({
        angle: newAngle,
        scaleX: newScale,
        scaleY: newScale,
        left: this.canvas.width / 2,
        top: this.canvas.height / 2
      }, {
        duration: 450,
        onChange: () => {
          this.canvas.renderAll()
        },
        easing: fabric.util.ease['easeInOutSine'],
        onComplete: () => {
          this.canvas.renderAll()
          this.currentlyRotating = false
        }
      })

      unUi.$emit('scaleChanged')
    },

    setInitialScaleSliderValue () {
      this.imageState.scale = this.currentImage.scaleFactor * 100
      this.imageState.scaleMin = this.currentImage.scaleFactor * 100

      var obj = this.canvas.getActiveObject()

      if (obj) {
        obj.set({
          angle: this.currentImage.exifOrientation,
          left: this.canvas.width / 2,
          top: this.canvas.height / 2
        })
        this.canvas.renderAll()
      }
    },

    centerImage () {
      var obj = this.canvas.getActiveObject()
      if (obj) {
        obj.set({
          left: this.canvas.width / 2,
          top: this.canvas.height / 2
        })
        this.canvas.renderAll()
      }
    },

    setInitialColorFilterValues () {
      // TODO eliminate magic constants numbers here
      this.applyColorFilter(this.imageState.colorFilters[6], 6)
    },

    setInitialColorFilterUiValues () {
      // TODO eliminate magic constants numbers here
      this.imageState.colorFilters.forEach(cFilter => {
        cFilter.modelState = cFilter.index === 8
      })
    },

    setInitialLightValues () {
      this.imageState.brightness = 0
      this.imageState.contrast = 0
    },

    resetImage () {
      this.setInitialScaleSliderValue()
      this.setInitialColorFilterUiValues()
      this.setInitialLightValues()
    }
  },

  mounted () {
    unUi.$on('resetScale', () => {
      this.setInitialScaleSliderValue()
    })

    unUi.$on('resetBrightness', () => {
      this.setInitialLightValues()
    })

    unUi.$on('resetFilters', () => {
      this.setInitialColorFilterValues()
    })

    unUi.$on('centerImage', () => {
      this.centerImage()
    })
  },

  components: {
    Slider,
    Rotate45
  }
}
</script>
<style lang='scss'>
.el-slider {
  width: 70%;
  display: inline-block;
  vertical-align: middle;
  margin: 0 5% 0 0;

  .el-slider__runway {
    height: 1px;
    background-color: #D5D5D5;

    .el-slider__bar {
      background-color: black;
      height: 1px;
    }

    .el-slider__button-wrapper {
      top: -17px;

      .el-slider__button {
        width: 14px;
        height: 14px;
        border: none;
        background-color: black;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.37);
      }
    }
  }
}

.control-label {
  display: inline-block;
  vertical-align: middle;

  @include font-size(0.95);
}

.control-rotate {
  display: inline-block;
  width: 2rem;
  vertical-align: middle;
  cursor: pointer;

  i {
    @include font-size(1.85);

    padding-top: 0.4rem;
  }
}

.control-item-row {
  display: flex;

  .control-label {
    align-self: center;
    height: 1.3rem;
    color: #A5A5A5;
  }

  .el-slider {
    flex-grow: 1;

    &.mar_r {
      margin: 0 5% 0 0;
    }

    &.mar_l {
      margin: 0 0 0 5%;
    }
  }
}

.controls-scale-rotate, .controls-brightness-contrast {
  padding: 0rem 2rem;

  @include respond-to("small") {
    padding: 0 2.75rem;
  }
}

.controls-filters {
  position: relative;
  padding: 0rem 2rem;

  .control-label {
    display: block;
  }

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;

    li {
      position: relative;
      list-style-type: none;
      display: inline-block;
      text-align: center;
      cursor: pointer !important;
      transition: all 0.2s ease-in-out;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;

      img {
        position: relative;
        display: block;
        width: 3rem;
        margin: 0 auto;
      }

      .control-label {
        color: #A5A5A5;
        display: block;
        margin-top: 0.8rem;
        white-space: nowrap;
      }

      .canvas-container, .filter-img-el {
        position: relative;
        border-radius: 5rem;
        border: 2px solid transparent;
        position: relative;
        margin: 0 auto;
        overflow: hidden;
        z-index: 1;
        transition: all 0.15s ease-in-out;
        transform: translate3d(0, 0, 0) scale(1);
      }

      &.selected {
        .canvas-container, .filter-img-el {
          border: 2px solid black;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.35);
          transform: translate3d(0, 0, 0) scale(1.11);
        }

        .control-label {
          color: black;
        }
      }

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 5;
        cursor: pointer;
      }

      &:hover {
        .canvas-container, .filter-img-el {
          transform: translate3d(0, 0, 0) scale(1.11);
        }

        &.selected {
          .canvas-container, .filter-img-el {
            transform: translate3d(0, 0, 0) scale(1.11);
          }
        }
      }

      @include respond-to("small") {
        margin-right: 2.5rem;
      }
    }
  }
}

body.customizer-activated,
body.env-gold {
  .cannot-apply-filter-warning {
    p {
      color: darken($c_alerts_warning, 10);
      display: inline-block;
      background-color: rgba($c_alerts_warning, 0.1);
      padding: 0.5rem 2rem;
      border-radius: 1rem;
      margin: 0;

      @include respond-to("small") {
        font-size: 1.5rem;
        line-height: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/design-controls/ControlOptions.vue